import type { CartV4 } from '@redteclab/api/clients/cart-service'
import type { AxiosResponse } from 'axios'

import {
  CartServiceBase,
  type ICartService,
} from 'shared/services/api/cartService/common'
import type { ServiceParameters } from 'shared/services/api/commonTypes'

const BACKEND_API_VERSION = 'v4'

const GET_CART_TIMEOUT = 15000 // 15 seconds

class CartServiceV4 extends CartServiceBase implements ICartService {
  constructor(props: ServiceParameters) {
    super({ ...props, apiVersion: BACKEND_API_VERSION })
  }

  public getCartUrl = (): string =>
    `/cart-service/${this.apiVersion}/${this.tenantPath}/${this.language}/user`

  async fetchCart<T = CartV4>(
    purgeMessages?: boolean,
    nowZipCode?: string,
    includeMaxDosage?: boolean
  ): Promise<AxiosResponse<T>> {
    const shouldPurge: boolean = purgeMessages || false
    const shouldIncludeMaxDosage: boolean = includeMaxDosage || true

    const response: AxiosResponse<T> = await this.get(this.getCartUrl(), {
      params: {
        disabledRefresh: false,
        purgeMessages: `${shouldPurge}`,
        nowZipCode,
        includeMaxDosage: `${shouldIncludeMaxDosage}`,
      },
      timeout: GET_CART_TIMEOUT,
    })

    this.logger.debug(`${this.constructor.name} fetch cart!`, 'dataFetching')
    return response
  }
}

export default CartServiceV4
